import { PointsRvStatement } from './types'
import client from '../../client'
import { ResponseSuccess } from '../../types'

export const getPointsRvStatement = async () =>
  await client.get<ResponseSuccess<PointsRvStatement>>(`v1/statement`)
